// load jquery and bootstrap globally
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;